import type { ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

interface FilterSectionProps {
  title: string
  children: ReactNode
  className?: string
}

export const FilterSection = ({
  title,
  children,
  className,
}: FilterSectionProps) => {
  return (
    <section className={clsx(s.section, className)}>
      <h2 className={clsx('bold-18', s.title)}>{title}</h2>
      {children}
    </section>
  )
}
